import React, { Component } from "react";
import Collapse from "reactstrap/lib/Collapse";
import { configuration } from "../../appConfig";
import PageNo from "./PageNo";
import Axios from "axios";
import ".././newstyle.css";
// import ".././newfooterstyle.css";
import "../../views/Dashboard/qrlist.css";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');


export default class ReportFooter extends Component {
  state = {
    insurenceProviderInfo: [],

    fallbackInfo: {},
  };

  async componentDidMount() {
    await this.getFallbackDetails();
    await this.getInsuranceName();
    this.getInsurenceClients();
  }

  getFallbackDetails = async () => {
    const url = configuration.getFallbackDetails + `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);
    let fallback_data = {};
    
    if (res.data.success !== false) {
        let company_logo = res.data.company_logo ? configuration.getFallbackLogoPath + localStorage.getItem("partnerId") + "/" + res.data.company_logo : require("../../assets/img/brand/Adi.png");
        
      fallback_data = {
        Logo: company_logo,
        Email: res.data.company_email || "sales@adi-gmbh.com",
        CompanyName: res.data.company_name || "Auto Damage Inspection GmbH",
        Website: res.data.company_website || "https://adi-gmbh.com",
        Address: res.data.company_address || "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
        PrimaryColor: res.data.primary_color || "#FF0000",
        SecondaryColor: res.data.secondary_color || "#000000",
        PrimaryContact: res.data.contact_number || "08954809487",
        RegisterNo: res.data.company_registration_number || "HRB1234",
      };
    } else {
      fallback_data = {
        Logo: require("../../assets/img/brand/Adi.png"),
        Email: "sales@adi-gmbh.com",
        CompanyName: "Auto Damage Inspection GmbH",
        Website: "https://adi-gmbh.com",
        Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
        PrimaryColor: "#FF0000",
        SecondaryColor: "#000000",
        PrimaryContact: "08954809487",
        RegisterNo: "HRB1234",
      };
    }
    this.setState({ fallbackInfo: fallback_data });
  };

  getInsuranceName = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
      } else {
        localStorage.setItem("InsurenceName", "");
        // this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
      }
    } else {
      localStorage.setItem("InsurenceName", "");
      // this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
    }
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");
    let InsurenceName = localStorage.getItem("InsurenceName");
    if (InsurenceName === 'null') {
      InsurenceName = null;
    }
    if (InsurenceName && partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;

      Axios.get(url).then((res) => {
        if (res.data) {
          let insurenceProviderInfo;
          res.data.map((data, index) => {
            if (data.Name === InsurenceName) {
              insurenceProviderInfo = data;
            }
          });
          this.setState({ insurenceProviderInfo: insurenceProviderInfo });
        } else {
          this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
        }
      });
    } else {
      this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
    }
  };

  _onImageError = () => {
    let insurenceProviderInfo = this.state.insurenceProviderInfo;
    insurenceProviderInfo.Logo = require("../../assets/img/brand/logo.png");
    this.setState({ insurenceProviderInfo: insurenceProviderInfo });
  };

  render() {
    const pdfHeader = localStorage.getItem("pdfHeader");
    const pdfFooter = localStorage.getItem("pdfFooter");
    const partnerId = localStorage.getItem("partnerId");
    const userSession = localStorage.getItem("userSession");
    const selectedFile = localStorage.getItem("selectedFile");
    const data = userSession ? JSON.parse(userSession) : {};
    const { insurenceProviderInfo, fallbackInfo } = this.state;
    const date = new Date();

    // if (!pdfFooter) {
    //   return (
    //     <div
    //       className="pdfFooter row"
    //       style={{ float: "left", display: "flex", width: "100%" }}
    //     >
    //       <img
    //         onError={() => this._onImageError()}
    //         src={
    //           pdfFooter
    //             ? `${configuration.imagePath}/scanImages/${partnerId}/${pdfFooter}`
    //             : "/footer.jpg"
    //         }
    //         height="100"
    //         alt="footer logo not uploaded"
    //         style={{ flex: 1, width: "100%" }}
    //       />
    //     </div>
    //   );
    // } else {
    return (
      <>
      <div className="container p-0 bottom-footer-pdf">
        {/* <div className="row p-0">
              <div className="col-lg-1 col-md-12 col-sm-12 p-0">
                <p style={{ backgroundColor: this.state.insurenceProviderInfo.PrimaryColor ? `${this.state.insurenceProviderInfo.PrimaryColor}` : '#D92029'}}></p>
                <p style={{backgroundColor: this.state.insurenceProviderInfo.SecondaryColor ? `${this.state.insurenceProviderInfo.SecondaryColor}` : 'black'}}></p>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 p-0 call-info">
                <div className="row p-0">
                  <div className="col-4"> */}
        {/* <img style={{width:50, height:50}} src={require("../../assets/img/brand/phone.png")} alt="Phone Icon" /> */}
        {/* <p><i className="fa fa-phone-square fa-2x" aria-hidden="true" style={{ color: this.state.insurenceProviderInfo.PrimaryColor ? `${this.state.insurenceProviderInfo.PrimaryColor}` : '#D92029'}}></i></p>
                  </div>
                  <div className="col-8 p-0">
                    <h1>+{insurenceProviderInfo.PrimaryContact}</h1>
                    <h1>+{insurenceProviderInfo.SecondaryContact}</h1>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 p-0 call-info">
                <div className="row p-0">
                  <div className="col-4"> */}
        {/* <img style={{width:50, height:50}} src={require("../../assets/img/brand/web.png")} alt="Phone Icon" /> */}
        {/* <p><i className="fa fa-chrome fa-2x" aria-hidden="true" style={{ color: this.state.insurenceProviderInfo.PrimaryColor ? `${this.state.insurenceProviderInfo.PrimaryColor}` : '#D92029'}}></i></p>
                  </div>
                  <div className="col-8 p-0">
                    <h1>{insurenceProviderInfo.Website}</h1>
                    <h1>{insurenceProviderInfo.Email}</h1>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 p-0 call-info address-info">
                <div className="row p-0">
                  <div className="col-3"> */}
        {/* <img src={require("../../assets/img/brand/location.png")} style={{width:50, height:50}} alt="Phone Icon" /> */}
        {/* <p><i className="fa fa-map-marker fa-2x" aria-hidden="true" style={{ color: this.state.insurenceProviderInfo.PrimaryColor ? `${this.state.insurenceProviderInfo.PrimaryColor}` : '#D92029'}}></i></p>
                  </div>
                  <div className="col-9 p-0">
                    <h1>Auto Damage Inspection GmbH</h1>
                    <h1 style={{textTransform:'capitalize'}}>{insurenceProviderInfo.Address}</h1>
                  </div>
                </div>
              </div>
              <div className="col-lg-1 col-md-12 col-sm-12 p-0">
                <p style={{ backgroundColor: this.state.insurenceProviderInfo.PrimaryColor ? `${this.state.insurenceProviderInfo.PrimaryColor}` : '#D92029'}}></p>
                <p style={{backgroundColor: this.state.insurenceProviderInfo.SecondaryColor ? `${this.state.insurenceProviderInfo.SecondaryColor}` : 'black'}}></p>
              </div>
            </div> */}

        {/* NEW Footer Design */}

        {/* <div className="row p-0 new-bottom-footer-details">
          <div className="col-lg-1 col-md-1 col-sm-12 p-0">
            <p
              style={{
                backgroundColor:
                  this.state.fallbackInfo.PrimaryColor || "#FF0000",
              }}
            ></p>
            <p
              style={{
                backgroundColor: this.state.fallbackInfo.SecondaryColor
                  ? `${this.state.fallbackInfo.SecondaryColor}`
                  : "black",
              }}
            ></p>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 p-0 call-info">
            <img src={fallbackInfo.Logo} alt="Phone Icon" />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 p-0 call-info text-center mt-3">
            <h1
              className="text-center font-weight-bold"
              style={{ color: "#000" }}
            >
              {fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"}
            </h1>
            <h1
              className="text-center"
              style={{ textTransform: "capitalize", fontWeight: "bold" }}
            >
              {fallbackInfo.Address}
            </h1>
            <div className="row bottom-footer-contact-details">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <h1 className="text-center d-block d-lg-block d-md-block d-sm-block">
                  <i
                    className="fa fa fa-phone-square fa-lg"
                    aria-hidden="true"
                    style={{ color: "#000" }}
                  ></i>
                  &nbsp; {insurenceProviderInfo.PrimaryContact}
                </h1>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <h1 className="text-center">
                  <i
                    className="fa fa fa-chrome fa-lg"
                    aria-hidden="true"
                    style={{ color: "#000" }}
                  ></i>{" "}
                  &nbsp; {fallbackInfo.Website}
                </h1>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <h1 className="text-center d-block d-lg-block d-md-block d-sm-block">
                  <i
                    className="fa fa fa-envelope fa-lg"
                    aria-hidden="true"
                    style={{ color: "#000" }}
                  ></i>{" "}
                  &nbsp; {fallbackInfo.Email}
                </h1>
              </div>
            </div>
          </div>
        
          <div className="col-lg-2 col-md-2 col-sm-12 p-0 call-info">
            <img
              src={require("../../assets/img/brand/logo.png")}
              alt="Phone Icon"
            />
          </div>
          <div className="col-lg-1 col-md-1 col-sm-12 p-0 side_bg_color">
            <p
              style={{
                backgroundColor:
                  this.state.fallbackInfo.PrimaryColor || "#FF0000",
              }}
            ></p>
            <p
              style={{
                backgroundColor: this.state.fallbackInfo.SecondaryColor
                  ? `${this.state.fallbackInfo.SecondaryColor}`
                  : "black",
              }}
            ></p>
          </div>
        </div>
        <div className="row copyright-footer justify-content-center p-0">
          <div className="col-12 p-0">
            <PageNo current="2" total="2" carNo={data.regNo} />
          </div>
        </div> */}







          <div className="row p-0 new-bottom-footer-details">
            <div className="col-lg-1 col-md-1 col-sm-12 p-0 side_bg_color">
              <p className="side_bg_color"
                style={{
                  backgroundColor:
                    this.state.fallbackInfo.PrimaryColor || "#FF0000",
                }}
              ></p>
              <p className="side_bg_color"
                style={{
                  backgroundColor: this.state.fallbackInfo.SecondaryColor
                    ? `${this.state.fallbackInfo.SecondaryColor}`
                    : "black",
                }}
              ></p>
            </div>
            <div className="col-lg-10 col-md-10 col-sm-12 p-0">
                <div className="row p-0 align-items-center">
                  <div className="col-lg-3 col-md-3 col-sm-12">
                    <img width="100%" src={fallbackInfo.Logo} />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 ">
                  <h3 className="text-center font-weight-bold footer-center-text" style={{ color: "#000" }} > {fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"} </h3>
                  <h6 className="text-center font-weight-bold" style={{ color: "#000" }} > {fallbackInfo.Address}</h6>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                  {partnerId !== '10-200410' && partnerId !== '21-220221' && <img className="w-100" src={require("../../assets/img/brand/dns-adi.jpg")} />}
                  {(partnerId === '10-200410' || partnerId === '21-220221') && <img className="w-100" src={require("../../assets/img/brand/Report-footer.png")} />}
                  </div>
                </div>
                <div className="row p-0 contact_info" >
                  <div className="col-12 p-0">
                    <div className="row p-0">
                        <div className="col-lg-4 col-md-4 col-sm-12 contact_details">
                        <p className=" mb-1 mt-1"  style={{ color: "#000", fontSize:"15px" }}> <i className="fa fa fa-phone-square fa-lg" aria-hidden="true" style={{ color: "#000" }} ></i> {(insurenceProviderInfo && insurenceProviderInfo.PrimaryContact) ? insurenceProviderInfo.PrimaryContact : fallbackInfo.contact_number} </p>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12 contact_details">
                        <p className="text-center mb-1 mt-1"  style={{ color: "#000", fontSize:"15px" }}> <i className="fa fa fa-chrome fa-lg"   aria-hidden="true" style={{ color: "#000" }} ></i> {fallbackInfo.Website} </p>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12 contact_details">
                        <p className=" mb-1 mt-1"  style={{ color: "#000", fontSize:"15px" }}> <i className="fa fa fa-envelope fa-lg"   aria-hidden="true" style={{ color: "#000" }} ></i> {fallbackInfo.Email} </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0 copyright_footer">
                  <PageNo current="2" total="2" carNo={data.regNo}  style="color:black" {...this.props}/>
                  </div>
                </div>
            </div>
            <div className="col-lg-1 col-md-1 col-sm-12 p-0 side_bg_color">
              <p className="side_bg_color"
                style={{
                  backgroundColor:
                    this.state.fallbackInfo.PrimaryColor || "#FF0000",
                }}
              ></p>
              <p className="side_bg_color"
                style={{
                  backgroundColor: this.state.fallbackInfo.SecondaryColor
                    ? `${this.state.fallbackInfo.SecondaryColor}`
                    : "black",
                }}
              ></p>
            </div>
          </div>

      </div>
      
      {/* <div className="full_width_footer">
    <div className="full_width_row">
        <div className="footer_width_1">
            <p style={{ backgroundColor: this.state.fallbackInfo.PrimaryColor || "#FF0000", }}></p>
            <p style={{ backgroundColor: this.state.fallbackInfo.SecondaryColor ? `${this.state.fallbackInfo.SecondaryColor}` : "black", }}></p>
        </div>
        <div className="footer_width_2">
            <div className="new_footer_row">
                <img src={fallbackInfo.Logo} />
            </div>
            <div className="new_footer_row_2">
                <h2 className="text-center font-weight-bold" style={{ color: "#000" }} > {fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"} </h2>
                <h4 className="text-center" style={{ textTransform: "capitalize", fontWeight: "bold" }} > {fallbackInfo.Address} </h4>
                <div className="new_footer_row_2_1">
                    <div className="new_footer_row_2_1_1">
                        <p className="text-center"> <i className="fa fa fa-phone-square fa-lg" aria-hidden="true" style={{ color: "#000" }} ></i> &nbsp; {insurenceProviderInfo.PrimaryContact} </p>
                    </div>
                    <div className="new_footer_row_2_1_1">
                        <p className="text-center"> <i className="fa fa fa-chrome fa-lg" aria-hidden="true" style={{ color: "#000" }} ></i>{" "} &nbsp; {fallbackInfo.Website} </p>
                    </div>
                    <div className="new_footer_row_2_1_1">
                        <p className="text-center"> <i className="fa fa fa-envelope fa-lg" aria-hidden="true" style={{ color: "#000" }} ></i>{" "} &nbsp; {fallbackInfo.Email} </p>
                    </div>
                </div>
            </div>
            
            <div className="new_footer_row">
                <img src={fallbackInfo.Logo} />
            </div>
        </div>
        <div className="footer_width_1">
            <p style={{ backgroundColor: this.state.fallbackInfo.PrimaryColor || "#FF0000", }}></p>
            <p style={{ backgroundColor: this.state.fallbackInfo.SecondaryColor ? `${this.state.fallbackInfo.SecondaryColor}` : "black", }}></p>
        </div>
    </div>
</div>         */}







    {/* <div className="container bottom-footer-pdf p-0">
      <div className="row p-0">
        <div className="col-12 p-0">
          <div className="row p-0">
            <div className="col-lg-3 p-0">
              <div className="row p-0">
                <div className="col-lg-4 p-0">
                    <p
                    style={{
                      backgroundColor:
                        this.state.fallbackInfo.PrimaryColor || "#FF0000",
                      }}
                  ></p>
                  <p
                    style={{
                      backgroundColor: this.state.fallbackInfo.SecondaryColor
                        ? `${this.state.fallbackInfo.SecondaryColor}`
                        : "black",
                      }}
                  ></p>
                </div>
                <div className="col-lg-8 p-0">
                  <img className="w-100" src={fallbackInfo.Logo} alt="Phone Icon" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 p-0 text-center">
              <div className="row call-info p-0">
                <div className="col-12 p-0">
                  <h1
                    className="text-center font-weight-bold"
                    style={{ color: "#000" }}
                  >
                    {fallbackInfo.CompanyName || "Auto Damage Inspection GmbH"}
                  </h1>
                </div>
                <div className="col-12 p-0">
                  <h1
                    className="text-center"
                    style={{ textTransform: "capitalize", fontWeight: "bold" }}
                  >
                    {fallbackInfo.Address}
                  </h1>
                </div>
              </div>
              <div className="row bottom-footer-contact-details call-info p-0">
                <div className="col-lg-4 p-0">
                <h1 className="text-center d-block d-lg-block d-md-block d-sm-block">
                  <i
                    className="fa fa fa-phone-square fa-lg"
                    aria-hidden="true"
                    style={{ color: "#000" }}
                  ></i>
                  &nbsp; {insurenceProviderInfo.PrimaryContact}
                </h1>
                </div>
                <div className="col-lg-4 p-0">
                <h1 className="text-center">
                  <i
                    className="fa fa fa-chrome fa-lg"
                    aria-hidden="true"
                    style={{ color: "#000" }}
                  ></i>{" "}
                  &nbsp; {fallbackInfo.Website}
                </h1>
                </div>
                <div className="col-lg-4 p-0">
                <h1 className="text-center d-block d-lg-block d-md-block d-sm-block">
                  <i
                    className="fa fa fa-envelope fa-lg"
                    aria-hidden="true"
                    style={{ color: "#000" }}
                  ></i>{" "}
                  &nbsp; {fallbackInfo.Email}
                </h1>
                </div>
              </div>
            </div>
            <div className="col-lg-3 p-0">
              <div className="row p-0">
                <div className="col-lg-8 p-0">
                <img className="w-100"
              src={require("../../assets/img/brand/logo.png")}
              alt="Phone Icon"
            />
                </div>
                <div className="col-lg-4 p-0">
                    <p
                    style={{
                      backgroundColor:
                        this.state.fallbackInfo.PrimaryColor || "#FF0000",
                      }}
                  ></p>
                  <p
                    style={{
                      backgroundColor: this.state.fallbackInfo.SecondaryColor
                        ? `${this.state.fallbackInfo.SecondaryColor}`
                        : "black",
                      }}
                  ></p>
                </div>
              </div>
            </div>
            <div className="col-12">
              <PageNo current="2" total="2" carNo={data.regNo} />
            </div>
          </div>
        </div>
      </div>
    </div> */}
      </>
    );
    // }
  }
}
